import React from "react";
import ContentLoader from "react-content-loader";

const BugContentLoader = () => {
  return <ContentLoader />;
};

export default BugContentLoader;
